import script from "./FacadeWorkView.vue?vue&type=script&setup=true&lang=js"
export * from "./FacadeWorkView.vue?vue&type=script&setup=true&lang=js"

import "./FacadeWorkView.vue?vue&type=style&index=0&id=63ff454e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63ff454e"]])

export default __exports__